import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ComList from '../ComList';

const monthFormat = "YYYY-MM";

class UpdateEducation extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        const params = {
            ...(record || {}),
        };
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        }, () => {
            this.queryVitaeList('STUDY_SPECIAL');
            this.queryVitaeList('ACADEMIC_QUALIFICATION');
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            classOptions: [],
            subjectOptions: [],
            qualificationOptions: [],
        });
    }

    queryVitaeList = (typeName) => {
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeList,
            data: {typeName},
            dataType: 'json',
            doneResult: res => {
                const { vitaeList = [] } = res;
                const options = vitaeList.map(item => {
                    const { vitaeDictId, chName, enName, childList } = item;
                    return {
                        zh: chName,
                        en: enName,
                        value: vitaeDictId,
                        child: childList,
                    };
                });
                if (typeName === 'STUDY_SPECIAL') {
                    this.setState({ classOptions: options }, () => {
                        const { params: { specialTypeId } } = this.state;
                        specialTypeId && this.setsubjectOptions(specialTypeId);
                    });
                } else if (typeName === 'ACADEMIC_QUALIFICATION') {
                    this.setState({ qualificationOptions: options });
                }
            }
        };
        $.sendRequest(options);
    }

    getRenderList = () => {
        const { isChinese } = this.props;
        const {
            params: {
                specialTypeId
            },
            classOptions = [],
            subjectOptions = [],
            qualificationOptions = [],
        } = this.state;
        classOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        subjectOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        qualificationOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        const renderList = [{
            zh: '毕业时间',
            en: 'Time',
            key: 'graduationTime',
            require: true,
            option: {
                type: 'monthPicker',
                allowClear: false,
                format: monthFormat,
                disabled: !isChinese,
                style: { width: 200 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            }
        }, {
            zh: '学校名称',
            en: 'University',
            key: isChinese ? 'schoolNameChinese' : 'schoolNameEnglish',
            require: true,
            option: {
                type: 'input',
                style: { width: 200 },
                placeholder: isChinese ? '请输入' : 'Please input ',
            }
        }, {
            zh: '专业',
            en: 'Major',
            key: 'specialTypeId',
            require: true,
            option: {
                type: 'select',
                allowClear: true,
                list: classOptions,
                disabled: !isChinese,
                style: { width: 200 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            },
            warning: isChinese ? '门类' : 'class',
        }];
        if (specialTypeId == 60) {
            renderList.push({
                key: isChinese ? 'specialOtherChinese' : 'specialOtherEnglish',
                require: true,
                colon: false,
                option: {
                    type: 'input',
                    style: { width: 200 },
                    placeholder: isChinese ? '补充其他说明' : 'Please supply other instructions',
                },
                display: {
                    symbol: 'eq',
                    key: 'specialTypeId',
                    toName: true,
                    value: isChinese ? '其他' : 'Others',
                },
            });
        } else {
            renderList.push({
                key: 'studySpecialId',
                require: true,
                colon: false,
                option: {
                    type: 'select',
                    allowClear: true,
                    list: subjectOptions,
                    disabled: !isChinese,
                    style: { width: 200 },
                    placeholder: isChinese ? '请选择' : 'Please select ',
                },
                warning: isChinese ? '专业名称' : 'major name',
                display: {
                    symbol: 'eq',
                    key: 'specialTypeId',
                }
            }, {
                key: isChinese ? 'specialOtherChinese' : 'specialOtherEnglish',
                require: true,
                colon: false,
                option: {
                    type: 'input',
                    style: { width: 200 },
                    placeholder: isChinese ? '补充其他说明' : 'Please supply other instructions',
                },
                display: {
                    symbol: 'eq',
                    key: 'studySpecialId',
                    toName: true,
                    value: isChinese ? '其他' : 'Others',
                },
            });
        }
        renderList.push({
            zh: '学历',
            en: 'Degree',
            key: 'academicQualificationId',
            require: true,
            option: {
                type: 'select',
                allowClear: false,
                disabled: !isChinese,
                list: qualificationOptions,
                style: { width: 200 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            }
        });
        const setName = (item) => {
            if (isChinese) {
                item.name = item.zh;
            } else {
                item.name = item.en;
            }
        };
        const loopArr = (arr) => {
            if (Array.isArray(arr)) {
                arr.forEach(item => loopArr(item));
            } else {
                setName(arr);
            }
        };
        loopArr(renderList);
        this.renderList = renderList;
    }

    checkValue = param => {
        const { params } = this.state;
        const { name, key, require, option, warning, display } = param;
        const { placeholder } = option;
        
        let noError = true;
        if (require) {
            if (!params[key] && !display) {
                message.warning(`${placeholder}${warning || name || ''}`);
                noError = false;
            } else {
                if (display) {
                    const { symbol, key, value = null } = display;
                    if (symbol === 'eq') {
                        if (value) {
                            const list = this.renderList || [];
                            const tar = list.find(i => i.key === key);
                            const arr = tar.option.list || [];
                            const o = arr.find(a => a.value == params[key]);
                            if (o && o.name === value && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        } else {
                            if (params[key] && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        }
                    }
                }
            }
        }
        return noError;
    }

    submit = () => {
        const {
            isEdit,
            params,
            params: {
                graduationTime,
            },
        } = this.state;
        const { userId, isChinese } = this.props;
        this.getRenderList();
        const renderList = this.renderList || [];
        const hasError = renderList.every(item => {
            if (Array.isArray(item)) {
                return item.every(i => this.checkValue(i));
            } else {
               return this.checkValue(item);
            }
        });
        if (!hasError) {
            return;
        }
        if (isEdit) {
            params.graduationTime = graduationTime ? graduationTime.slice(0, 7) : graduationTime;
        }
        params.type = isChinese ? 'CHINESE' : 'ENGLISH';
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.saveEducationBackground,
            data: {
                userId,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    setsubjectOptions = (value) => {
        const { classOptions } = this.state;
        const option = classOptions.find(i => i.value == value) || {};
        const { child = [] } = option;
        const subjectOptions = child.map(i => ({
            value: i.vitaeDictId,
            zh: i.chName,
            en: i.enName,
        }));
        this.setState({ subjectOptions });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;

        if (key === 'specialTypeId') {
            params.studySpecialId = undefined;
            params.specialOtherChinese = '';
            params.specialOtherEnglish = '';
            this.setsubjectOptions(value);
        }
        if (key === 'studySpecialId') {
            params.specialOtherChinese = '';
            params.specialOtherEnglish = '';
        }
        this.setState({ params });
    }

    render() {
        const { isEdit, visible, loading, params } = this.state;
        this.getRenderList();
        const list = this.renderList || [];
        return (
            <Modal
                title={`${isEdit ? '修改' : '新增'}教育背景`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                confirmLoading={loading}
                maskClosable={false}
                width="400px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ComList
                            list={list}
                            params={params}
                            onChange={(value, key) => this.handleChange(value, key)}
                        />
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateEducation;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/UpdateEducation.js